import FamilyImage from "../../images/myfamily.png";

function StoryView() {
  return (
    <div className="flex flex-col pt-24 justify-content items-center bg-base-200">
      <div className="shadow-xl flex flex-col bg-base-100 card p-12">
        <img src={FamilyImage} alt="my mom, brother, and me" className="w-96 mx-auto"/>
        <h1 className="font-bold text-2xl mt-4">Our Story</h1>
        <p className="mt-2 whitespace-pre-line">
          {`Hi, I'm Michelle! I was born in Koreatown, LA, and I'm the daughter of South Korean immigrants. My mom has worked hard to support me and my brother as we grew up, and as I think about her getting older, I've found it hard to know what to ask and how my brother and I should prepare to take care of her as she ages.

          LettuceTalk was my answer to this challenge, to help Korean-American families like mine prepare early for our parents growing older in as delightful, grateful, and thoughtful of a way as possible. Problems like these are why I founded Impact Moonshots, an AI studio for social impact— I want to create joyful, world-class technology for communities and social challenges that usually go ignored in Silicon Valley.

          To all us immigrant children out there with aging parents, I see you, and I hope this reaches you with a lot of love.

          Warm wishes,
          Michelle
          `}
        </p>
        
        <a href="https://imoonshots.com" target="_blank" className="mt-4 w-fit btn btn-primary flex flex-col cursor-pointer">
          <label>Follow Our Journey</label>
          <label>우리의 여정을 따라오세요</label>
        </a>

      </div>
    </div>
  );
}

export default StoryView;


